module.exports = __webpack_public_path__ + "img/sales.20709161.svg";